<!-- 留存 -->

<template>
  <div class="dashboard-container tab-margin">
    <!-- 搜索 S -->
    <div class="top-search tab-padding">
      <div class="search">
        <div class="content">
          <div class="flex-2">
            <el-form label-position="top" inline label-width="120px">
              <el-form-item label="媒体渠道" class="form-label">
                <el-select
                  filterable
                  style="width: 300px"
                  v-model="temp.source"
                  placeholder="媒体渠道:所有"
                  multiple
                >
                  <el-option
                    v-for="item in mediaOptions"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="国家/地区" class="form-label">
                <el-select
                  filterable
                  style="width: 300px"
                  v-model="temp.country"
                  multiple
                  placeholder="国家/地区:所有"
                >
                  <el-option
                    v-for="item in countryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="分组维度"
                class="form-label"
                style="width: 50%"
              >
                <el-select
                  v-model="temp.groupby"
                  style="width: 300px"
                  placeholder="分组维度:所有"
                  multiple
                >
                  <el-option
                    v-for="item in optionsAgg"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="flex-1">
            <el-form label-position="top" inline label-width="120px">
              <el-form-item label="日期范围" class="form-label">
                <el-date-picker
                  v-model="timeWrap"
                  type="datetimerange"
                  align="right"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="search-wrap">
          <div class="search-line" v-show="!shouqi">
            <div
              class="flex align-ct mg-b-10"
              v-for="(item, index) in searchList"
              :key="index"
            >
              <el-select
                class="mg-r-10"
                style="width: 300px"
                v-model="item.type"
                placeholder="请选择"
                @change="changeFilterOption"
              >
                <el-option
                  v-for="item in filterOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>

              <el-input
                v-if="item.type === 1"
                v-model="temp.pkg"
                placeholder="请输入App名称"
                clearable
                style="width: 240px"
              />

              <el-select
                clearable
                v-if="item.type === 2"
                v-model="temp.os"
                style="width: 240px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-input
                v-if="item.type === 3"
                v-model="temp.os_ver"
                placeholder="请输入操作系统版本"
                clearable
                style="width: 240px"
              />

              <el-input
                v-if="item.type === 4"
                v-model="temp.app_ver"
                placeholder="请输入App版本"
                clearable
                style="width: 240px"
              />

              <!-- <el-input
                v-if="item.type === 5"
                v-model="temp.country"
                placeholder="请输入国家"
                clearable
                style="width: 240px"
              /> -->

              <el-input
                v-if="item.type === 6"
                v-model="temp.model"
                placeholder="请输入手机型号"
                clearable
                style="width: 240px"
              />

              <el-input
                v-if="item.type === 7"
                v-model="temp.vip"
                placeholder="请输入VIP"
                clearable
                style="width: 240px"
              />

              <el-input
                v-if="item.type === 8"
                v-model="temp.offset"
                placeholder="请输入偏移量"
                clearable
                style="width: 240px"
              />

              <i
                class="el-icon-delete mg-l-10 cursor"
                @click="delSearchLine(index)"
              ></i>
            </div>
          </div>
          <div class="flex-between">
            <div class="left">
              <el-button icon="el-icon-plus" @click="addSearchLine"
                >添加更多过滤项</el-button
              >
              <i
                v-if="!shouqi"
                class="el-icon-arrow-up mg-l-20 cursor"
                @click="showSearch(true)"
              ></i>
              <i
                v-else
                class="el-icon-arrow-down mg-l-20 cursor"
                @click="showSearch(false)"
              ></i>
            </div>
            <div class="right">
              <el-button
                type="primary"
                icon="el-icon-download"
                class="search-btn"
                :loading="loading"
                @click="exportTable"
                >导出</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-search"
                class="search-btn"
                @click="search"
                :loading="loading"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 搜索 E -->
    <!-- <div class="table-title">当前App：{{curAppName}}</div> -->
    <div class="tab-container">
      <div class="tab-container-bottom">
        <el-table
          v-loading="loading"
          :data="
            nList.slice(
              (pagination.page - 1) * pagination.limit,
              pagination.page * pagination.limit
            )
          "
          empty-text="暂无数据"
          style="width: 100%; min-height: 500px"
          :row-style="{ background: '#FCFDFF' }"
          :header-cell-style="{ background: '#2d3a5b', color: '#ffffff' }"
        >
          <el-table-column
            label="日期"
            prop="date"
            min-width="180"
            align="center"
            fixed
            v-if="nList.length > 0"
          >
          </el-table-column>

          <!-- 分组维度 -->
          <template v-for="item in optionsAgg">
            <el-table-column
              :key="item.label"
              :label="item.label"
              :prop="item.value"
              align="center"
              min-width="200"
              v-if="showGropBy(item.value)"
            >
            </el-table-column>
          </template>
          <!-- 分组维度 end -->

          <el-table-column
            align="center"
            v-for="(item, index) in hList"
            :key="index"
            min-width="120"
            :label="labelName(item)"
          >
            <template slot-scope="scope">
              <span v-if="scope.row[item]"
                >{{
                  ((scope.row[item] / scope.row[hList[0]]) * 100).toFixed(2)
                }}%
              </span>
              <br />
              <span v-if="scope.row[item]">{{ scope.row[item] }}</span>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          :total="pagination.total"
          :page.sync="pagination.page"
          :limit.sync="pagination.limit"
          @pagination="getList()"
        />
        <div style="width: 100px; height: 20px" />
      </div>
    </div>

    <back-to-top
      :custom-style="myBackToTopStyle"
      :visibility-height="300"
      :back-position="50"
      transition-name="fade"
    />
    <back-to-bottom
      :visibility-height="300"
      :back-position="50"
      transition-name="fade"
    ></back-to-bottom>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { retainedList } from "@/api/inout.js";
import { countryList, mediaList } from "@/api/app.js";
import Pagination from "@/components/Pagination";
import BackToTop from "@/components/BackToTop";
import BackToBottom from "@/components/BackToBottom";

export default {
  name: "event",
  computed: {
    ...mapGetters(["name", "cur_app", "pickerOptions"]),
  },
  components: {
    Pagination,
    BackToTop,
    BackToBottom,
  },
  watch: {
    cur_app(newVal) {
      this.temp.pkg = newVal;
      this.search();
    },
  },
  data() {
    return {
      myBackToTopStyle: {
        right: "50px",
        bottom: "120px",
        width: "40px",
        height: "40px",
        "border-radius": "4px",
        "line-height": "45px", // 请保持与高度一致以垂直居中 Please keep consistent with height to center vertically
        background: "#37474F", // 按钮的背景颜色 The background color of the button
      },
      options: [
        {
          value: "android",
          label: "Android",
        },
        {
          value: "ios",
          label: "IOS",
        },
      ],
      optionsType: [
        {
          value: 1,
          label: "日活量",
        },
        {
          value: 2,
          label: "新增",
        },
      ],
      optionsP: [
        {
          value: 1,
          label: "天",
        },
        {
          value: 2,
          label: "小时",
        },
      ],
      mediaOptions: [],

      countryOptions: [],
      optionsAgg: [
        {
          value: "campaign_name",
          label: "campaign",
        },
        {
          value: "ad_group_id",
          label: "ad_group",
        },
        {
          value: "creative_id",
          label: "creative",
        },
        {
          value: "source",
          label: "渠道",
        },
        // {
        //   value: "pkg",
        //   label: "包名",
        // },
        // {
        //   value: "os",
        //   label: "操作系统",
        // },
        {
          value: "os_ver",
          label: "操作系统版本",
        },
        {
          value: "app_ver",
          label: "App版本",
        },
        {
          value: "country",
          label: "国家",
        },
        {
          value: "model",
          label: "手机型号",
        },
        {
          value: "vip",
          label: "用户类型",
        },
      ],
      temp: {
        pkg: "",
        os: "",
        os_ver: "",
        app_ver: "",
        country: [],
        model: "",
        vip: "",
        offset: "",
        source: [],
        groupby: [],
      },
      curAppName: "",
      loading: false,
      timeWrap: [],
      pagination: {
        limit: 30,
        page: 1,
        total: 0,
      },
      tableData: [],
      nList: [],
      hList: [],

      filterOptions: [
        {
          value: 1,
          label: "包名",
          model: "pkg",
          disabled: false,
        },
        // {
        //   value: 2,
        //   label: "操作系统",
        //   model: "os",
        //   disabled: false,
        // },
        {
          value: 3,
          label: "操作系统版本",
          model: "os_ver",
          disabled: false,
        },
        {
          value: 4,
          label: "app版本",
          model: "app_ver",
          disabled: false,
        },
        {
          value: 6,
          label: "手机型号",
          model: "model",
          disabled: false,
        },
        {
          value: 7,
          label: "用户类型",
          model: "vip",
          disabled: false,
        },
        // {
        //   value: 8,
        //   label: "偏移量",
        //   model: "offset",
        //   disabled: false,
        // },
      ],
      filterList: [],
      searchList: [],
      shouqi: false,
    };
  },

  created() {
    const that = this;
    const start = new Date();
    const end = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    that.timeWrap[0] = that.formatData(start);
    that.timeWrap[1] = that.formatData(end);

    this.curAppName = this.$route.query.name;

    countryList().then((res) => {
      this.countryOptions = res;
    });
    mediaList().then((res) => {
      // console.log(res);
      this.mediaOptions = res;
    });

    this.temp.pkg = localStorage.getItem("curPkg");
  },

  methods: {
    exportTable() {
      let tHeader = [];
      let filterVal = ["date"].concat(this.temp.groupby).concat(this.hList);
      filterVal.map((item) => {
        tHeader.push(this.formatHead(item));
      });
      const data = this.formatJson(filterVal, this.nList);

      import("@/vendor/Export2Excel").then((excel) => {
        excel.export_json_to_excel({
          header: tHeader, //表头 必填
          data, //具体数据 必填
          filename: "事件留存-导出", //非必填
          autoWidth: true, //非必填
          bookType: "xlsx", //非必填
        });
      });
    },
    formatJson(filterVal, tableData) {
      return tableData.map((v) => {
        return filterVal.map((j) => {
          return v[j];
        });
      });
    },
    formatHead(val) {
      let _re = "";
      let reg = /^[0-9]+.?[0-9]*/; //判断是否是数字。
      if (val === "date") {
        _re = "日期";
      }
      if (reg.test(val)) {
        _re = "第" + val + "天";
      }
      this.optionsAgg.map((item) => {
        if (item.value === val) {
          _re = item.label;
        }
      });
      return _re;
    },
    // 表单是否显示groupBy 分组维度
    showGropBy(val) {
      if (this.nList.length > 0) {
        if (val in this.nList[0]) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    changeFilterOption() {
      this.filterOptions.forEach((it) => {
        it.disabled = false;
      });
      this.searchList.forEach((item) => {
        this.filterOptions.forEach((p) => {
          if (item.type === p.value) {
            p.disabled = true;
          }
        });
      });
    },
    showSearch(val) {
      this.shouqi = val;
    },
    delSearchLine(index) {
      let _t = this.searchList[index].type;
      let _item =
        this.filterOptions.filter((item) => {
          return item.value === _t;
        })[0] || null;
      // 不清除包名
      if (_t !== 1 && _item) {
        this.temp[_item.model] = "";
      }
      this.searchList.splice(index, 1);
      this.changeFilterOption();
    },
    addSearchLine() {
      this.searchList.push({
        type: "",
      });
    },

    labelName(val) {
      return "Day" + val;
    },

    // 初始化日期
    formatData(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },

    getList() {
      console.log(this.pagination);
      // this.loading = true;
    },

    search() {
      if (this.timeWrap === null) {
        this.$message({
          message: "请选择日期",
          type: "warning",
        });
        return false;
      } else {
        this.loading = true;
        let params = JSON.parse(JSON.stringify(this.temp));
        let _params = {};
        params.s_dt = this.timeWrap[0];
        params.e_dt = this.timeWrap[1];
        // return false
        for (let key in params) {
          if (params[key]) {
            _params[key] = params[key];
          }
        }
        retainedList(_params)
          .then((res) => {
            let _start = new Date(this.timeWrap[0]).getTime();
            let _end = new Date(this.formatData(new Date())).getTime();
            // 所选时间间隔天
            let day = (_end - _start) / (1000 * 24 * 60 * 60);

            // 列表数据
            this.nList = res.data;
            // 表头 Day
            this.hList = [];
            for (let i = 0; i <= day; i++) {
              this.hList.push(i);
            }
            this.loading = false;
            this.pagination.total = res.data.length;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    reset() {
      this.hList = [];
      this.nList = [];
      Object.assign(this.$data.temp, this.$options.data.call(this).temp);
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex($ali, $jus) {
  display: flex;
  align-items: $ali;
  justify-content: $jus;
}

.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.top-search {
  display: flex;
  padding: 20px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #f0f3f7;
}
.table-container {
  min-height: 400px;
  margin-top: 20px;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eff2f7;
}
.search {
  width: 100%;
  background: #ffffff;
  // border-radius: 10px;
  overflow: hidden;
  .content {
    @include flex(flex-start, space-between);
    // flex-direction: column;
    border-radius: 4px;
    // height: 76px;
    width: 100%;
    margin: 0 auto;
  }
}
.pageContain {
  @include flex(center, flex-end);
  margin-top: 20px;
}
.search-btn {
  background-color: #2d3a5b;
  border: #2d3a5b;
}
.reset-btn {
  background-color: #ffffff;
  color: #2d3a5b;
  border: 1px solid #2d3a5b;
}

.tab-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  // border: 1px solid #2d3a5b;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  &-top {
    width: 100%;
    color: #fff;
    background-color: rgba(45, 58, 91, 0.9);
    border-bottom: 1px solid #e4e7ed;
  }
  &-bottom {
    width: 100%;
  }
}
.active {
  color: #2d3a5b;
  background-color: #fff;
}
.tab-title {
  @include flex(center, center);
  width: 120px;
  height: 50px;
  cursor: pointer;
}
.table-tip {
  margin: 30px;
  font-size: 18px;
  font-weight: 400;
}
.table-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  margin-top: 20px;

  color: #2d3a5b;
  background-color: #ffffff;
}
.right-btns {
  float: right;
  padding-right: 20px;
}
.el-form-item {
  margin-bottom: 0;
}
</style>
